import {initTimer} from '../utils/slider-functions';
const selectorCircle = 'slider-pag__circle';
const swiperDelay = 3000;

const initPartnersSlider = () => {
  let interval = null;
  const swiper = new Swiper('.js-partners-slider', {
    autoplay: {
      delay: swiperDelay,
      disableOnInteraction: false,
    },
    slidesPerView: 'auto',
    navigation: {
      nextEl: '.partners__next',
      prevEl: '.partners__prev',
    },
    pagination: {
      el: '.partners__pag',
      type: 'bullets',
      clickable: true,
      renderBullet: (i, className) => {
        return `<span class="${className}">
          <span class="${selectorCircle}"></span>
        </span>`;
      },
    },
    init: false,
  });

  swiper.on('init', (obj) => {
    if (obj.pagination.el) {
      startCircle(obj.pagination.bullets[0]);
    }
  });

  swiper.on('toEdge', (obj) => {
    if (obj.pagination.el) {
      startCircle(obj.pagination.bullets[obj.pagination.bullets.length - 1]);
    }
  });

  swiper.on('slideChange', (obj) => {
    if (obj.pagination.el) {
      startCircle(obj.pagination.bullets[swiper.activeIndex]);
    }
  });

  setTimeout(() =>swiper.init(), 1000);

  function startCircle(bullet) {
    if (interval) {
      clearInterval(interval);
    }
    interval = initTimer(interval, bullet, selectorCircle, swiperDelay);
  }
};

export {initPartnersSlider};
